// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609211005/js/" + chunkId + "." + {"44":"9cdea95b","225":"1cc6b667","481":"4de41096","486":"a0b68b6a","770":"43d41f83"}[chunkId] + ".0.37298612095907224.chunk.js";
};